import React from 'react'
import styled from '@emotion/styled'
import { TradeConditionFlag } from 'api'
import { TextFlagButton } from 'view/components/buttons'
import { TextFlagButtonsContainer, TextFlagState } from 'view/components/buttons'
import { Field } from 'view/components/inputs'
import { Locale, Translation } from 'locale'
import * as constants from 'view/styles/constants'

export interface AxeTradeConditionButtonsProps {
  isAxed: boolean
  axeReadOnly?: boolean
  tradeConditionFlag: TradeConditionFlag
  readOnly?: boolean
  onUpdate: (isAxed: boolean, tradeConditionFlag: TradeConditionFlag) => unknown
  dataTestId?: string
}

const StyledTextFlagButton = styled(TextFlagButton)<{ state: TextFlagState }>`
  &[disabled] {
    opacity: 1;
    color: ${props => (props.state === TextFlagState.On ? constants.CORE_PRIMARY : constants.CORE_PRIMARY_4)};
    background-color: ${props => (props.state === TextFlagState.On ? constants.ACCENT_PRIMARY : constants.CORE_PRIMARY_2)};
  }
  &:not(:last-of-type) {
    margin-right: 1px;
  }
  &:first-of-type {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  &:last-of-type {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
`

export const AxeTradeConditionButtons: React.FunctionComponent<AxeTradeConditionButtonsProps> = props => {
  const { isAxed, axeReadOnly = false, dataTestId, tradeConditionFlag, readOnly, onUpdate } = props

  const handleUpdateAxed = () => {
    onUpdate(!isAxed, tradeConditionFlag)
  }

  const handleUpdateTradeConditionFlag = (selectedTradeConditionFlag: TradeConditionFlag) => {
    const newTradeConditionFlag = tradeConditionFlag === selectedTradeConditionFlag ? TradeConditionFlag.NONE : selectedTradeConditionFlag
    onUpdate(isAxed, newTradeConditionFlag)
  }

  return (
    <TextFlagButtonsContainer data-test-id={dataTestId}>
      <StyledTextFlagButton
        dataTestId={`${dataTestId}-AxeButton`}
        state={isAxed ? TextFlagState.On : TextFlagState.Off}
        disabled={axeReadOnly || readOnly}
        onClick={handleUpdateAxed}>
        {Locale.translate(Translation.TC_BUTTON_AXE)}
      </StyledTextFlagButton>
      <StyledTextFlagButton
        dataTestId={`${dataTestId}-RollButton`}
        state={tradeConditionFlag === TradeConditionFlag.ROLL ? TextFlagState.On : TextFlagState.Off}
        disabled={readOnly}
        onClick={() => handleUpdateTradeConditionFlag(TradeConditionFlag.ROLL)}>
        {Locale.translate(Translation.TC_BUTTON_ROLL)}
      </StyledTextFlagButton>
      <StyledTextFlagButton
        dataTestId={`${dataTestId}-UnwindButton`}
        state={tradeConditionFlag === TradeConditionFlag.UNWIND ? TextFlagState.On : TextFlagState.Off}
        disabled={readOnly}
        onClick={() => handleUpdateTradeConditionFlag(TradeConditionFlag.UNWIND)}>
        {Locale.translate(Translation.TC_BUTTON_UNWIND)}
      </StyledTextFlagButton>
      <StyledTextFlagButton
        dataTestId={`${dataTestId}-SubButton`}
        state={tradeConditionFlag === TradeConditionFlag.SUB ? TextFlagState.On : TextFlagState.Off}
        disabled={readOnly}
        onClick={() => handleUpdateTradeConditionFlag(TradeConditionFlag.SUB)}>
        {Locale.translate(Translation.TC_BUTTON_SUB)}
      </StyledTextFlagButton>
    </TextFlagButtonsContainer>
  )
}

export const AxeTradeConditionButtonsField = Field(AxeTradeConditionButtons)
